import fetch from '../core/axios'

let urls = {
  actList: '/imc/merchant/act/list',// （活动分页列表）
  appsList: '/imc/merchant/apps',// （营销工具列表）
  modifyuserhead: '/imc/merchant/modifyuserhead',// 修改头像
  tagsList: '/imc/merchant/tags/list',// 获取标签列表
  tagsSave: '/imc/merchant/tags/save',// 保存标签
  tagsDel: '/imc/merchant/tags/del',// 删除标签
  actGetall: '/imc/merchant/act/getall',// 获取活动全部信息
  prizeList: '/imc/merchant/prize/list',// 获取商户所有奖品
  actSave: '/imc/merchant/act/save',// 保存活动基础信息
  actSavedesc: '/imc/merchant/act/savedesc',// 保存活动规则/须知

  actSaveWinningRules: '/imc/merchant/act/savewinningrules',// 活动中奖规则设置
  prizeSave: '/imc/merchant/act/prize/save',// 保存活动奖品
  prizeSaveIds: '/imc/merchant/act/prize/saveidx',// 保存活动奖品权重等信息
  
  actSkinSave: '/imc/merchant/act/skin/save',// 保存活动皮肤
  wxserviceList: '/imc/merchant/wxservice/list',// 获取商家微信自定义公众号/服务号列表
  wxservicePaymentSettings: '/imc/merchant/wxservice/payment/settings',// 保存公众号支付配置
  actRedpackSettings: '/imc/merchant/act/redpack/settings',// 保存活动红包发送配置
  actPrizeStock: '/imc/merchant/act/prize/stock',// 增加奖品库存
  userprizeList: '/imc/merchant/userprize/list',// 获取商户用户奖品列表
  userprizeSendprize: '/imc/merchant/userprize/sendprize',// 发放商户的用户奖品/修改用户奖品状态
  productList: '/imc/merchant/product/list',// 产品列表
  productBindact: '/imc/merchant/product/bindact',// 产品关联活动
  
  uploadcoupon: '/imc/merchant/uploadcoupon',// 上传优惠券文件
  actSelect: '/imc/merchant/act/select',// 获取活动列表[下拉选择使用
  saveActsetting: '/imc/merchant/act/saveactsetting',// 获取活动列表[下拉选择使用

  giftAlllist: '/imc/merchant/gift/alllist',// 获取平台礼品分页列表
  giftCreategiftorder: '/imc/merchant/gift/creategiftorder',// 创建礼品订单，礼品结算

  jicard: '/imc/merchant/jicard/cards',

  aipuUserprizes: '/imc/merchant/aipu/userprizes'
  
};

let config = {
  headers:{'Content-Type':'multipart/form-data'}
};

export default {
  giftAlllist(params) {
    return fetch.post(urls.giftAlllist, params)
  },
  giftCreategiftorder(params) {
    return fetch.post(urls.giftCreategiftorder, params)
  },
  actList(params) {
    return fetch.post(urls.actList, params)
  },
  appsList(params) {
    return fetch.post(urls.appsList, params)
  },
  modifyuserhead(params) {
    return fetch.post(urls.modifyuserhead, params)
  },
  tagsList(params) {
    return fetch.post(urls.tagsList, params)
  },
  tagsSave(params) {
    return fetch.post(urls.tagsSave, params)
  },
  tagsDel(params) {
    return fetch.post(urls.tagsDel, params)
  },
  actGetall(params) {
    return fetch.post(urls.actGetall, params)
  },
  prizeList(params) {
    return fetch.post(urls.prizeList, params)
  },
  actSave(params) {
    return fetch.post(urls.actSave, params)
  },
  actSavedesc(params) {
    return fetch.post(urls.actSavedesc, params)
  },
  actSaveWinningRules(params) {
    return fetch.post(urls.actSaveWinningRules, params)
  },
  prizeSave(params) {
    return fetch.post(urls.prizeSave, params)
  },
  prizeSaveIds(params) {
    return fetch.post(urls.prizeSaveIds, params)
  },
  actSkinSave(params) {
    return fetch.post(urls.actSkinSave, params)
  },
  wxserviceList(params) {
    return fetch.post(urls.wxserviceList, params)
  },
  wxservicePaymentSettings(params) {
    return fetch.post(urls.wxservicePaymentSettings, params)
  },
  actRedpackSettings(params) {
    return fetch.post(urls.actRedpackSettings, params)
  },
  actPrizeStock(params) {
    return fetch.post(urls.actPrizeStock, params)
  },
  userprizeList(params) {
    return fetch.post(urls.userprizeList, params)
  },
  userprizeSendprize(params) {
    return fetch.post(urls.userprizeSendprize, params)
  },
  productList(params) {
    return fetch.post(urls.productList, params)
  },
  productBindact(params) {
    return fetch.post(urls.productBindact, params)
  },
  uploadcoupon(params, prizeId) {
    return fetch.post(urls.uploadcoupon + '?prizeId=' + prizeId, params)
  },
  actSelect(params) {
    return fetch.post(urls.actSelect, params)
  },
  saveActsetting(params) {
    return fetch.post(urls.saveActsetting, params)
  },
  jicard(params) {
    return fetch.post(urls.jicard, params)
  },
  aipuUserprizes(params) {
    return fetch.post(urls.aipuUserprizes, params)
  }
}



// WEBPACK FOOTER //
// ./src/api/api.js